module.exports = __webpack_public_path__ + "media/images/page-next-3a7dad139639c35df4069191e5d2d633.svg";